import React from 'react'
import { Helmet } from 'react-helmet-async'
import { injectIntl } from 'react-intl'
import FormattedMessage from '../../components/FormattedMessage/FormattedMessage'
import UserRewardHistory from './UserRewardHistory'

import './MyRewards.scss'

const MyRewards = ({ intl }) => {
  const label = intl.formatMessage({ id: 'page.myRewardsPage.title.heroTitle' })

  return (
    <div className="myrewards-page">
      <Helmet>
        <title>{label}</title>
        <meta name="description" content="your description" />
      </Helmet>
      <div className="container mt-5 mb-5" role="main" aria-label={label}>
        <h1 className="page-title">
          <FormattedMessage id="page.myRewardsPage.title.heroTitle" />
        </h1>
        <UserRewardHistory />
      </div>
    </div>
  )
}

export default injectIntl(MyRewards)
